<template>
  <div 
    class="ob-nav"
    :style="{
      position: stikcy ? 'sticky' : 'relative',
      top: navOffsetTop,
      backgroundColor,
      color: color,
      zIndex: zIndex
    }"
  >
    <div 
      ref="navContent"
      class="ob-nav-content"
    >
      <div class="ob-nav-content_left">
        <slot name="left"></slot>
      </div>
      <div class="ob-nav-content_center">
        <slot name="center"></slot>
      </div>
      <div class="ob-nav-content_right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, toRefs, computed } from 'vue'

export default {
  name: 'ObNav',
  props: {
    top: {
      type: [Number, String],
      default: ''
    },
    stikcy: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'var(--color-text-primary)',
    },
    zIndex: {
      type: [String, Number],
      default: 400
    }
  },
  setup (props) {
    const { top, stikcy } = toRefs(props)

    const navContent = ref(null)

    const navOffsetTop = computed(() => {
      if (!stikcy.value) return 'unset'
      const offsetTop = top.value || 0
      return typeof(offsetTop) === 'string' ? offsetTop : `${offsetTop}px`
    })

    const fixedWrapperHeight = computed(() => {
      return `${navContent.value?.offsetHeight}px`
    })
    return {
      top,
      navContent,
      navOffsetTop,
      fixedWrapperHeight,
    }
  }
}

</script>


<style lang="postcss" scoped>
  .ob-nav {
    z-index: 400;
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 1200px;
    padding: 0 64px;
    box-sizing: border-box;
    background-color: var(--color-background-primary);
  }
  
  .ob-nav-content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    /* width: 1200px; */
    width: 100%;
    height: 51px;
    &_left,&_center,&_right {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      &:empty {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1023px) {
    .ob-nav {
      padding: 0 20px;
      min-width: unset;
    }
    .ob-nav-content {
      height: 50px;
    }
  }
</style>